var React = require('react');

function CheckmarkIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.16663 6.83325L4.49996 10.1666L12.8333 1.83325","stroke":"current","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

CheckmarkIconInline.defaultProps = {"width":"14","height":"12","viewBox":"0 0 14 12","fill":"none"};

module.exports = CheckmarkIconInline;

CheckmarkIconInline.default = CheckmarkIconInline;
